var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductSettingsPage.Pagination.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-073b44d3!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductSettingsPage.Pagination.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/productsettings/ProductSettingsPage.Pagination.vue
// module id = 695
// module chunks = 2